import React from 'react'
import Hadear from './layout/Hadear'
import { Outlet } from 'react-router-dom'
import Footer from './layout/Footer'
import Menu from './Menu'

const MainLayout = () => {
  return (
    <>
        <Hadear/>
        <Menu/>
        <Outlet/>
        <Footer/>
    </>
  )
}

export default MainLayout